import { baseTypography } from '@mehilainen/design-system-tokens/typography';
// NOTE: If the tokens do not contain all values, they must be manually coded into stories that the args cannot be chosen
// * no button large variant, see Button.stories.tsx
// * no chip large variant, see Chip.stories.tsx
// https://zeroheight.com/095c4083c/v/latest/p/61a956-professional
export const professionalTokens = {
    uiElementTypography: {
        dropdownRow: baseTypography.size[300].rem,
        selectorModalTitle: baseTypography.size[300].rem,
        datePickerDate: baseTypography.size[300].rem,
        datePickerColumenTitle: baseTypography.size[200].rem,
    },
    uiElementButton: {
        sizeSmall: {
            fontSize: baseTypography.size[200].rem,
            height: '24px',
            squareBorderRadius: 0,
        },
        sizeMedium: {
            fontSize: baseTypography.size[300].rem,
            height: '32px',
            squareBorderRadius: 0,
        },
        sizeLarge: {},
    },
    uiElementInputFields: {
        sizeSmall: {
            labelFontSize: baseTypography.size[200].rem,
            labelFontWeight: baseTypography.weight.Regular,
            contentFontSize: baseTypography.size[300].rem,
            assistiveTextSize: baseTypography.size[200].rem,
            assistiveTextWeight: baseTypography.weight.Regular,
            height: '40px',
        },
        sizeMedium: {
            labelFontSize: baseTypography.size[200].rem,
            labelFontWeight: baseTypography.weight.Regular,
            contentFontSize: baseTypography.size[300].rem,
            assistiveTextSize: baseTypography.size[200].rem,
            assistiveTextWeight: baseTypography.weight.Regular,
            height: '48px',
        },
        common: {
            borderRadius: 0,
            borderColor: 'Gray300',
            labelFilledColor: 'Gray700',
            paddingLeft: 12,
        },
    },
    uiElementSelections: {
        iconSize: '20px',
        toggleWidth: '24px',
        toggleHeight: '14px',
        thumbSize: '7px',
        labelSize: baseTypography.size[300].rem,
        labelWeight: baseTypography.weight.Medium,
        subLabelSize: baseTypography.size[200].rem,
        subLabelWeight: baseTypography.weight.Regular,
    },
    uiElementChips: {
        sizeSmall: {
            height: '24px',
            fontSize: baseTypography.size[400].rem,
            padding: '8px',
        },
        sizeMedium: {
            height: '40px',
            fontSize: baseTypography.size[400].rem,
            padding: '8px',
        },
    },
    uiElementToggleButton: {
        sizeSmall: {
            height: '24px',
            fontSize: baseTypography.size[200].rem,
            padding: '8px',
        },
        sizeMedium: {
            height: '32px',
            fontSize: baseTypography.size[300].rem,
            padding: '8px',
        },
        sizeLarge: {},
    },
    uiElementTabs: {
        fontSize: baseTypography.size[300].rem,
        lineColor: 'Black',
    },
    uiElementAlert: {
        borderRadius: '0px',
        borderLeft: '2px solid',
        textColor: '600',
        iconColor: '600',
    },
    uiElementAccordion: {
        titleFontSize: baseTypography.size[300].rem,
        contentDefaultFontSize: baseTypography.size[200].rem,
        iconSize: '24px',
    },
    values: {
        inputLabelPlacement: 'notched',
    },
};
